import { useCurrencyStore } from "~/stores/currencyStore";
import { fetchCurrencies } from "~/services/masterdataService";

const useCurrency = (userLanguageCode) => {
  async function initCurrency() {
    const currencyStore = useCurrencyStore();
    const currencyMasterData = await fetchCurrencies(userLanguageCode)
      .then((response) => response.data)
      .catch((error) => {
        throw error;
      });

    const usdCurrencyConversionRates = currencyMasterData.find(
      (currency) => currency.code.en === "USD",
    );
    if (currencyStore.currencyRates["USD"]) {
      currencyStore.currencyRates["USD"] = 1;
    }

    usdCurrencyConversionRates.conversionRates.forEach(
      (currencyConversionRate) => {
        currencyStore.currencyRates[currencyConversionRate.isoCode.en] =
          currencyConversionRate.rate.en;
      },
    );

    currencyMasterData.forEach((currencyData) => {
      currencyStore.currencySymbols[currencyData.code.en] =
        currencyData.symbol.en;
    });
    const preferredCurrency = getCookieFor("preferredCurrency");
    if (preferredCurrency) {
      currencyStore.selectedCurrency = preferredCurrency;
    } else {
      currencyStore.selectedCurrency = "local";
    }
  }

  function getCookieFor(cookieKey) {
    const cookieString = document.cookie;
    const cookieArray = cookieString.split(";");
    const cookies = {};
    cookieArray.forEach((cookieElement) => {
      const singleCookieAsArray = cookieElement.trim().split("=");
      cookies[singleCookieAsArray[0]] = singleCookieAsArray[1];
    });
    return cookies[cookieKey];
  }

  return {
    initCurrency,
  };
};

export default useCurrency;
